import React from "react";
import "./styles.scss";
// (Os imports do fontawesome não estão sendo usados neste trecho específico,
// mas mantive caso sejam usados em outra parte do arquivo original não mostrada)
import {
  faBars,
  faTimes,
  faAngleDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconAgilidade from "@src/assets/icon-agilidade.png";
import IconExpertise from "@src/assets/icon-expertise.png";
import IconCredibilidade from "@src/assets/icon-credibilidade.png";
import { useTranslation } from "react-i18next";

const Diferenciais = () => {
  const { t } = useTranslation();

  return (
    <section className="container">
      {/* <div className="section-nossos-diferenciais"> */}
      <div id="header-nossos-diferenciais">
        {/* Títulos principais */}
        <h2 id="txt-nossos">{t("secaoDiferencial.titulo")}</h2>
        <h2 id="txt-diferenciais">{t("secaoDiferencial.subtitulo")}</h2>
      </div>
      <div id="conteudo-nossos-diferenciais">
        {/* Card 1: Agilidade */}
        <div className="card-diferencial">
          <img src={IconAgilidade} className="icons" alt="Ícone Agilidade" />
          <p className="titulo-do-diferencial">
            {t("secaoDiferencial.primeiroDiferencial")}
          </p>
          <p className="descricao-do-diferencial">
            {t("secaoDiferencial.descricaoPrimeiroDiferencial")}
          </p>
        </div>

        {/* Card 2: Expertise */}
        <div className="card-diferencial">
          <img src={IconExpertise} className="icons" alt="Ícone Expertise" />
          <p className="titulo-do-diferencial">
            {t("secaoDiferencial.segundoDiferencial")}
          </p>
          <p className="descricao-do-diferencial">
            {t("secaoDiferencial.descricaoSegundoDiferencial")}
          </p>
        </div>

        {/* Card 3: Credibilidade */}
        <div className="card-diferencial">
          <img
            src={IconCredibilidade}
            className="icons"
            alt="Ícone Credibilidade"
          />
          <p className="titulo-do-diferencial">
            {t("secaoDiferencial.terceiroDiferencial")}
          </p>
          <p className="descricao-do-diferencial">
            {t("secaoDiferencial.descricaoTerceiroDiferencial")}
          </p>
        </div>
      </div>
      {/* </div> */}
    </section>
  );
};

export default Diferenciais;
